/**
 * Service to interact with the user-configurations middleware API.
 *
 * API: https://middleware.dev-dttsynergy.com/api/user-configurations
 *
 * Authentication: Authorization header (JWT from localStorage).
 * Same pattern as the Buildings app — no cookies needed.
 *
 * Methods used:
 *   GET — Fetch widget configurations for a specific user
 */

import axios from 'axios';

const BASE_URL = 'https://middleware.dev-dttsynergy.com/api';

const userConfigAxios = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

userConfigAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem('unified_videowall_cascais_token');
  if (token) config.headers['Authorization'] = token;
  return config;
});

/**
 * Fetches user configurations from the middleware API.
 *
 * @param {string} userPoolId   - Cognito User Pool ID (e.g., "eu-west-1_xxxxx")
 * @param {string} username     - Cognito username (e.g., "user_cascais")
 * @returns {Promise<object>}   The user's configuration object
 */
export const getUserConfigurations = async (userPoolId, username) => {
  const response = await userConfigAxios.get('/user-configurations', {
    params: {
      userName: username,
      userPool: userPoolId,
    },
  });
  return response.data;
};
